/**
 * GraphQL mutations for SLA/Contract primitive
 *
 * 6 mutations covering:
 * - Create SLA
 * - Start SLA (begin tracking)
 * - Pause/Resume SLA
 * - Mark SLA as met (success)
 * - Record breach (failure)
 */

import { gql } from '@apollo/client';
import { SLA_FIELDS } from './fragments';

/**
 * Create a new SLA
 * Generates backend Snowflake ID
 */
export const CREATE_SLA = gql`
  ${SLA_FIELDS}
  mutation CreateSLA($tenantId: String!, $input: CreateSLAInput!) {
    createSla(tenantId: $tenantId, input: $input) {
      ...SLAFields
    }
  }
`;

/**
 * Start SLA tracking
 * Sets startedAt timestamp, begins elapsed time calculation
 */
export const START_SLA = gql`
  ${SLA_FIELDS}
  mutation StartSLA($tenantId: String!, $slaId: String!) {
    startSla(tenantId: $tenantId, slaId: $slaId) {
      ...SLAFields
    }
  }
`;

/**
 * Pause SLA tracking
 * Stops elapsed time calculation temporarily
 */
export const PAUSE_SLA = gql`
  ${SLA_FIELDS}
  mutation PauseSLA($tenantId: String!, $slaId: String!) {
    pauseSla(tenantId: $tenantId, slaId: $slaId) {
      ...SLAFields
    }
  }
`;

/**
 * Resume paused SLA tracking
 * Resumes elapsed time calculation
 */
export const RESUME_SLA = gql`
  ${SLA_FIELDS}
  mutation ResumeSLA($tenantId: String!, $slaId: String!) {
    resumeSla(tenantId: $tenantId, slaId: $slaId) {
      ...SLAFields
    }
  }
`;

/**
 * Mark SLA as met (completed successfully within time)
 * Sets status to Met, updates compliance rate
 */
export const MARK_SLA_MET = gql`
  ${SLA_FIELDS}
  mutation MarkSLAMet($tenantId: String!, $slaId: String!) {
    markSlaMet(tenantId: $tenantId, slaId: $slaId) {
      ...SLAFields
    }
  }
`;

/**
 * Record SLA breach (failed to meet deadline)
 * Increments breach count, updates last breach time
 */
export const RECORD_SLA_BREACH = gql`
  ${SLA_FIELDS}
  mutation RecordSLABreach($tenantId: String!, $slaId: String!) {
    recordSlaBreach(tenantId: $tenantId, slaId: $slaId) {
      ...SLAFields
    }
  }
`;
